import { Component, OnInit } from '@angular/core';
import { ConfigService } from '../shared/services/config/config.service';
import { SettingsService } from '../shared/services/settings/settings.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { Router } from '@angular/router';

@Component({
  selector: 'ssg-auth',
  template: ''
})
export class AuthComponent implements OnInit {

  constructor(
    private readonly configService: ConfigService,
    private readonly router: Router,
    private readonly settingsSvc: SettingsService,
    private readonly oauthService: OAuthService) {
  }

  ngOnInit() {
   return this.initialize();
  }

  initialize() {
    if (this.configService.authenticationEnabled) {
      if (this.oauthService.hasValidAccessToken() && this.oauthService.hasValidIdToken()) {
        if (this.configService.identityEnabled) {
          this.oauthService.restartSessionChecksIfStillLoggedIn();
        }
      } else {
        this.oauthService.initImplicitFlow();
        this.oauthService.tryLogin();
      }
    }

    if (this.configService.verifyReferrer) {
      const referrer = document.referrer;
      let ultiproHost: string;
      try {
        ultiproHost = new URL(this.settingsSvc.ultiproUrl).host;
      } catch {
        ultiproHost = '';
      }
      if (!referrer || !this.settingsSvc.ultiproUrl || !referrer.includes(ultiproHost)) {
        return this.router.navigate([{outlets: { eepay: ['error', 403]}}], {replaceUrl: true});
      }
    }

    return this.router.navigate([{outlets: { eepay: 'dashboard'}}], {replaceUrl: true});
  }

}
